/**
 * AddToHomeScreenModal — инструкция для iOS/Safari.
 *
 * У Safari нет `beforeinstallprompt` (и вообще никакого программного пути
 * добавить сайт на экран «Домой») — единственный вариант это объяснить
 * руками: «Поделиться» → «На экран «Домой»».
 */
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Analytics } from '../analytics';

export default function AddToHomeScreenModal({ onClose }) {
  const { t } = useTranslation();
  const downOnBackdrop = useRef(false);

  useEffect(() => { Analytics.homeScreenIosInstructionsShown(); }, []);

  const handleClose = () => {
    Analytics.homeScreenIosInstructionsClosed();
    onClose();
  };

  const escRef = useRef(() => {});
  escRef.current = handleClose;
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') escRef.current(); };
    document.addEventListener('keyup', onKey);
    return () => document.removeEventListener('keyup', onKey);
  }, []);

  return (
    <div
      className="modal-overlay"
      onPointerDown={e => { downOnBackdrop.current = e.target === e.currentTarget; }}
      onClick={e => { if (e.target === e.currentTarget && downOnBackdrop.current) handleClose(); }}
    >
      <div className="modal" style={{ maxWidth: 380 }}>
        <div className="modal-header">
          <h3>{t('settings.homeScreen.iosModalTitle')}</h3>
          <button className="modal-close" onClick={handleClose} aria-label={t('common.close')}>×</button>
        </div>

        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {[1, 2, 3].map(n => (
            <div key={n} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <div style={{
                flexShrink: 0, width: 22, height: 22, borderRadius: '50%',
                background: 'var(--accent)', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 12, fontWeight: 700,
              }}>
                {n}
              </div>
              <p style={{ margin: 0, fontSize: 14, color: 'var(--text)', lineHeight: 1.5 }}>
                {t(`settings.homeScreen.iosStep${n}`)}
              </p>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleClose} data-ph="home_screen_ios_instructions_close">
            {t('settings.homeScreen.iosClose')}
          </button>
        </div>
      </div>
    </div>
  );
}
